import { Draft } from '@reduxjs/toolkit';

import { ICategoryData } from '../../index';

function editFailure(draft: Draft<ICategoryData>) {
  draft.edit.config.isLoading = false;
}

export default editFailure;
